module.exports = "#infoText1{margin-bottom:8px;color:#d45215}#networkName{width:100%;display:block;margin-top:8px;margin-bottom:calc(8px * 2)}\n"